class priceTable extends HTMLElement {
  constructor(){
    super();
    this.addEventListener('click', this.switchTab);
  }
  switchTab(e){
    const button = e.target.closest('.price-tab-button');
    if (!button) return;
    if (button && button.classList.contains('active')) return;
    
    const curButton = this.querySelector('.price-tab-button.active');
    if (curButton) curButton.classList.remove('active');
    
    const curContent = this.querySelector('.price-tab-content-item:not(.hidden)');
    if (curContent) curContent.classList.add('hidden');

    button.classList.add('active');
    const newContent = this.querySelector(`.${button.id}`);
    if (newContent) newContent.classList.remove('hidden');
    
  }
}

customElements.define('price-table', priceTable);